const compactTokens = new Intl.NumberFormat('en', {notation: 'compact'});
// Bedrock bills in USD while the rest of the admin renders CAD, so show the code
// rather than a bare '$'. Rounding to the cent is display-only — the stored value
// keeps sub-cent precision so per-turn costs still add up correctly on the session.
const formatCost = new Intl.NumberFormat('en-CA', {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'code',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatTokens = (usage) => {
  if (!usage) return null;
  const tokens = `${compactTokens.format(usage.totalTokens || 0)} tokens`;
  return usage.costUsd ? `${tokens} · ${formatCost.format(usage.costUsd)}` : tokens;
};

const USAGE_KEYS = ['inputTokens', 'outputTokens', 'totalTokens'];

// Adds one model call's usage to the running total of a streaming turn.
const addUsage = (current, incoming) => {
  if (!current && !incoming) return null;
  const result = USAGE_KEYS.reduce((acc, key) => {
    acc[key] = (current?.[key] || 0) + (incoming?.[key] || 0);
    return acc;
  }, {});
  if (current?.costUsd !== undefined || incoming?.costUsd !== undefined) {
    result.costUsd = (current?.costUsd || 0) + (incoming?.costUsd || 0);
  }
  return result;
};

const getMessageText = (message) => message.content || message.text || '';

const isAgentSender = (senderRn) => typeof senderRn === 'string' && senderRn.startsWith('RN:AGENT');

const mapSessionMessages = (messages) =>
  messages.map((m) => ({
    role: isAgentSender(m.senderRn) ? 'assistant' : 'user',
    text: getMessageText(m),
    createdAt: m.createdAt || null,
    usage: m.usage || null,
    stopped: m.stopped === true,
  }));

export {formatTokens, addUsage, getMessageText, mapSessionMessages};
